/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import { siteMetadata } from "../../gatsby-config"

function stripHtml(html) {
  return html.replace(/<[^>]+>/g, "")
}

const Seo = ({ description, lang, uri, meta, title, image, robots }) => {
  const { wp } = useStaticQuery(
    graphql`
      query {
        wp {
          generalSettings {
            title
            description
          }
        }
      }
    `
  )

  const metaDescription = description || wp.generalSettings?.description
  const defaultTitle = wp.generalSettings?.title


  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title || defaultTitle}
      meta={[
        {
          name: `description`,
          content: metaDescription ? stripHtml(metaDescription) : null,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription ? stripHtml(metaDescription) : null,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:image`,
          content:
            image ? `${siteMetadata.siteUrl}${image}` :
              `${siteMetadata.siteUrl}/og-image.jpg`,
        },
        {
          property: `twitter:image`,
          content:
            image ? `${siteMetadata.siteUrl}${image}` :
              `${siteMetadata.siteUrl}/og-image.jpg`,
        },
        {
          name: `twitter:card`,
          content: `summary_large_image`,
        },
        {
          name: `twitter:site`,
          content: `@jamulcasinosd`,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription ? stripHtml(metaDescription) : null,
        },
        {
          name: `article:publisher`,
          content: `https://www.facebook.com/JamulCasinoResort`,
        },
        {
          name: `robots`,
          content: robots || `index,follow`,
        },
        {
          name: 'og:url',
          content: `${process.env.SITE_URL || siteMetadata.siteUrl}${uri}`,
        }
      ].concat(meta)}
    >
      {uri ? <link rel="canonical" href={`${process.env.SITE_URL || siteMetadata.siteUrl}${uri}`} /> : null}
    </Helmet>
  )
}

Seo.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default Seo
